import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const RESULTS = ['crear imágenes con inteligencia artificial', 'generar voces profesionales', 'producir videos con IA', 'automatizar creación de contenido', 'usar IA para proyectos personales o negocios'];
export function ResultsSection() {
  return <section className="bg-gradient-to-br from-[#1a0533] via-[#2d1052] to-[#3b1466] py-24 px-4 relative" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <h2 className="text-4xl md:text-5xl font-black text-center text-[#FFD700] mb-16 drop-shadow-lg" data-id="element-177">
          ⚡ Lo que vas a poder hacer después de este curso
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-178">
          <a href="#comprar" className="block cursor-pointer group" data-id="element-179">
            <div className="rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(0,0,0,0.5)] border border-white/10 transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-180">
              <img src="https://cdn.magicpatterns.com/uploads/fL4kifiYEiASnV7pKj366U/hf_20260315_030029_2ff0e81d-cbd3-417c-a483-4653fdb24a62.jpg" alt="Resultados" className="w-full h-auto object-cover" width={1200} height={675} loading="lazy" decoding="async" data-id="element-181" />
            </div>
          </a>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4
        }} data-id="element-182">
            <p className="text-2xl text-white font-bold mb-8" data-id="element-183">
              Después de completar el entrenamiento vas a poder:
            </p>

            <ul className="space-y-6 mb-10" data-id="element-184">
              {RESULTS.map((item, i) => <li key={i} className="flex items-start gap-4 bg-black/30 p-4 rounded-xl border border-white/5" data-id="element-185">
                  <div className="bg-green-500/20 p-1 rounded-full mt-1" data-id="element-186">
                    <CheckIcon className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-187" />
                  </div>
                  <span className="text-xl text-white font-medium" data-id="element-188">{item}</span>
                </li>)}
            </ul>

            <div className="bg-[#FFD700]/10 border-l-4 border-[#FFD700] p-6 rounded-r-xl" data-id="element-189">
              <p className="text-xl text-[#c4b5d4] mb-2" data-id="element-190">En otras palabras…</p>
              <p className="text-2xl text-white font-bold" data-id="element-191">
                vas a entender cómo usar inteligencia artificial de verdad.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-192">
          <CTAButton data-id="element-193">🚀 ¡SÍ, QUIERO LOGRAR ESTO!</CTAButton>
        </div>
      </div>
    </section>;
}